<template>
  <div class="card" :class="widgetClasses">
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bold fs-3 mb-1">Produtos</span>

        <span class="text-muted mt-1 fw-semobold fs-7"
          >Últimos produtos cadastrados</span
        >
      </h3>
      <router-link
        to="/cadastros/produtos/editar"
        class="card-toolbar"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        data-bs-trigger="hover"
        title="Adicionar novo produto"
      >
        <a class="btn btn-sm btn-light-primary">
          <span class="svg-icon svg-icon-3">
            <inline-svg src="media/icons/duotune/arrows/arr075.svg" />
          </span>
          Novo Produto
        </a></router-link
      >
    </div>
    <div class="card-body py-3">
      <Datatable
        ref="table"
        :table-header="tableHeader"
        :table-data="tableData"
        :table-pagination="tablePagination"
        :page-sizes="pageSizes"
        :enable-items-per-page-dropdown="true"
        :hide-on-single-page="false"
        empty-table-text="Nenhum produto encontrado"
        :colors="true"
        @showFilter="false"
        :showFilters="false"
        :showPagination="false"
        class="mb-5 table border-0 table-row-dashed table-row-gray-300 align-middle gs-0 gy-4"
      >
        <template v-slot:cell-codigo="{ row: produto }">
          {{ produto.codigo }}
        </template>
        <template v-slot:cell-imagem="{ row: produto }">
          <div v-if="produto.imagem" class="symbol symbol-50px">
            <div
              class="symbol-label fs-2 fw-bold bg-light-dark"
              :style="{
                'background-image': `url(${
                  this.$utils.getUrl() + produto.imagem
                })`,
              }"
            ></div>
          </div>
          <div v-else class="symbol symbol-50px">
            <div :class="['symbol-label fs-2 fw-bold ' + produto.color]">
              {{
                produto.nome ? produto.nome.substring(0, 1).toUpperCase() : ""
              }}
            </div>
          </div>
        </template>
        <template v-slot:cell-nome="{ row: produto }">
          <div class="align-middle">
            <div>
              <span class="text-dark text-hover-primary mb-1 fs-4">
                {{ produto.nome }}
              </span>
              <span class="text-muted fw-bold d-block">
                {{ produto.descricao }}
              </span>
            </div>
          </div>
        </template>
        <template v-slot:cell-ean="{ row: produto }">
          {{ produto.ean }}
        </template>
        <template v-slot:cell-ativo="{ row: produto }">
          <span v-if="produto.ativo === '1'" class="badge badge-light-success"
            >Ativo</span
          >
          <span v-else class="badge badge-light-danger">Indisponível</span>
        </template>
        <template v-slot:cell-preco="{ row: produto }">
          {{ this.$utils.formatarNumero(produto.preco) }}
        </template>
        <template v-slot:cell-preco_promocao="{ row: produto }">
          {{ this.$utils.formatarNumero(produto.preco_promocao) }}
        </template>
        <template v-slot:cell-CreatedAt="{ row: cliente }">
          <div class="min-w-125px">
            {{ this.$utils.formatarDataHora(cliente.createdAt) }}
          </div>
        </template>
      </Datatable>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
export default {
  props: {
    widgetClasses: {
      type: String,
      required: false,
      default: "card-xl-stretch mb-xl-8",
    },
  },
  components: {
    Datatable,
  },
  methods: {
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(nome, '" +
          pesquisa +
          "') or contains(descricao, '" +
          pesquisa +
          "') or contains(ean, '" +
          pesquisa +
          "') or contains(cod_referencia, '" +
          pesquisa +
          "')";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or codigo eq " + pesquisa;
        }
        this.pesquisaAgrupada = false;
      } else {
        this.tableData.filterOData = "";
      }
    },
  },
  data() {
    return {
      showFilter: false,
      adicionar: false,
      tableHeader: [
        {
          name: "Código",
          key: "codigo",
          sortable: true,
        },
        {
          key: "imagem",
          sortable: false,
        },
        {
          name: "Nome",
          key: "nome",
          sortable: true,
        },
        {
          name: "Situação",
          key: "ativo",
          sortable: true,
        },
        {
          name: "Preço",
          key: "preco",
          sortable: true,
        },
        {
          name: "Preço promoção",
          key: "preco_promocao",
          sortable: true,
        },
        {
          name: "Data Cadastro",
          key: "CreatedAt",
          sortingField: "createdAt",
          sortable: false,
        },
      ],
      tableData: {
        store: "produto/getProdutoOData",
        selectOData:
          "?$select=id,codigo,nome,descricao,ativo,guid,cod_referencia,ean,imagem,preco,preco_promocao,createdAt",
        filterOData: "",
        search: "",
        defaultSort: "createdAt desc",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 5,
      },
      pageSizes: ["5"],
    };
  },
};
</script>

<style lang="scss" scoped></style>
